export function toDateInput(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
}

export function getMonthStart(date = new Date()) {
  return toDateInput(new Date(date.getFullYear(), date.getMonth(), 1));
}

export function getMonthEnd(date = new Date()) {
  return toDateInput(new Date(date.getFullYear(), date.getMonth() + 1, 0));
}

export function getCurrentIndianFinancialYearRange(date = new Date()) {
  const year = date.getFullYear();
  const fyStartYear = date.getMonth() >= 3 ? year : year - 1;

  return {
    fromDate: toDateInput(new Date(fyStartYear, 3, 1)),
    toDate: toDateInput(date)
  };
}

export const FINANCIALS_DATE_PRESETS = [
  {
    id: 'current-fy',
    label: 'Current Financial Year',
    getRange: () => getCurrentIndianFinancialYearRange()
  },
  {
    id: 'this-month',
    label: 'This month',
    getRange: () => ({
      fromDate: getMonthStart(),
      toDate: toDateInput(new Date())
    })
  },
  {
    id: 'last-month',
    label: 'Last month',
    getRange: () => {
      const now = new Date();
      const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
      const end = new Date(now.getFullYear(), now.getMonth(), 0);
      return {
        fromDate: toDateInput(start),
        toDate: toDateInput(end)
      };
    }
  },
  {
    id: 'this-year',
    label: 'This year',
    getRange: () => ({
      fromDate: toDateInput(new Date(new Date().getFullYear(), 0, 1)),
      toDate: toDateInput(new Date())
    })
  },
  {
    id: 'all-time',
    label: 'All time',
    getRange: () => ({
      fromDate: '2000-01-01',
      toDate: toDateInput(new Date())
    })
  }
];

export function getDefaultFinancialsDateRange() {
  return FINANCIALS_DATE_PRESETS.find((preset) => preset.id === 'this-month').getRange();
}
